export const RT_LIST = Array.from({ length: 16 }, (_, i) => i + 1);
export const AGAMA = ["Islam", "Kristen", "Katolik", "Hindu", "Buddha", "Konghucu", "Kepercayaan terhadap Tuhan YME"];
export const PERKAWINAN = ["Belum Kawin", "Kawin Tercatat", "Kawin Belum Tercatat", "Cerai Hidup", "Cerai Mati"];
export const SHDK = ["Kepala Keluarga", "Suami", "Istri", "Anak", "Menantu", "Cucu", "Orang Tua", "Mertua", "Famili Lain", "Pembantu", "Lainnya"];
export const PENDIDIKAN = [
  "Tidak/Belum Sekolah", "Belum Tamat SD/Sederajat", "Tamat SD/Sederajat", "SLTP/Sederajat", "SLTA/Sederajat",
  "Diploma I/II", "Akademi/Diploma III/Sarjana Muda", "Diploma IV/Strata I", "Strata II", "Strata III",
];
export const PEKERJAAN = [
  "Belum/Tidak Bekerja", "Mengurus Rumah Tangga", "Pelajar/Mahasiswa", "Pensiunan", "Pegawai Negeri Sipil (PNS)",
  "PPPK", "TNI", "POLRI", "Karyawan Swasta", "Karyawan BUMN/BUMD", "Wiraswasta", "Pedagang", "Petani/Pekebun",
  "Nelayan/Perikanan", "Peternak", "Buruh Harian Lepas", "Sopir", "Tukang", "Guru", "Tenaga Kesehatan",
  "Pendeta/Pastor/Ustadz", "Aparat Kampung/Kelurahan", "Pekerja Informal", "Lainnya",
];
export const GOLDAR = ["A", "B", "AB", "O", "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "Tidak Tahu"];
export const DISABILITAS = ["Tidak Ada", "Disabilitas Fisik", "Disabilitas Intelektual", "Disabilitas Mental", "Disabilitas Sensorik Netra", "Disabilitas Sensorik Rungu/Wicara", "Disabilitas Ganda"];
export const KELOMPOK = ["Bayi", "Balita", "Anak", "Produktif", "Lansia"];
export const KELOMPOK_DESC = { Bayi: "0–11 bln", Balita: "1–4 th", Anak: "5–14 th", Produktif: "15–64 th", Lansia: "65+ th" };
export const EKONOMI = ["Miskin", "Tidak Mampu", "Mampu"];

export const EMPTY_WARGA = {
  nik: "", no_kk: "", nama: "", jenis_kelamin: "", tempat_lahir: "", tanggal_lahir: "", golongan_darah: "Tidak Tahu",
  agama: "", status_perkawinan: "", shdk: "", pendidikan: "", pekerjaan: "", penghasilan: 0, kewarganegaraan: "WNI",
  status_oap: "", suku: "", nama_ayah: "", nama_ibu: "", alamat: "", rt: "", rw: "001", disabilitas: "Tidak Ada",
  no_hp: "", keterangan_masuk: "Penduduk Tetap",
};
